import type {ReactElement} from 'react';
import React from 'react';
import {Notification} from '@Components/notification';
import {useAppSelector} from '@/hooks';
import {useGetNumberOfActiveItems} from '@Hooks/poster-editor/useGetNumberOfActiveItems';

export function MultipleItemsSelectedNotificationTag(): ReactElement {
  const totalActiveItems = useGetNumberOfActiveItems();
  const isItemMultiSelectModeActive = useAppSelector((state) => {
    return state.posterEditor.posterObject?.itemsMultiSelect.enabled;
  });

  return isItemMultiSelectModeActive ? <Notification text={totalActiveItems.toString()} /> : <div />;
}
